import { Button } from "~/components/ui/button";

interface ModuleCardProps {
  title: string;
  description: string;
  href: string;
  external?: boolean;
}

export function ModuleCard({ title, description, href, external }: ModuleCardProps) {
  return (
    <div className="group relative rounded-2xl border border-gray-200 bg-white p-6 shadow-sm
      transition-all hover:bg-green-700/5 hover:shadow-md
      dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-green-500/10">
      <div className="flex h-full flex-col">
        <div className="flex-1 space-y-4">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
            {title}
          </h2>
          <p className="text-gray-600 dark:text-gray-300">
            {description}
          </p>
        </div>
        <div className="pt-6">
          <Button asChild className="w-full" variant="default">
            <a
              href={href}
              target={external ? "_blank" : undefined}
              rel={external ? "noopener noreferrer" : undefined}
            >
              Otevřít modul
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
}
